import { useState, useEffect, useCallback } from "react";
import apiFetch from "../../../../shared/services/apiClient";

// Extrae un mensaje legible de una respuesta de error de DRF. El bulk-save usa
// un serializer many=True, así que un fallo de validación llega como una LISTA
// alineada con las líneas enviadas (p. ej. [{}, {"monto": ["..."]}]) — sin la
// clave `error`. Devolvemos el primer mensaje concreto que encontremos.
function extraerError(json) {
  if (!json) return null;
  if (typeof json === "string") return json;
  if (json.error) return json.error;
  if (json.detail) return json.detail;
  const buscar = (v) => {
    if (!v) return null;
    if (typeof v === "string") return v;
    if (Array.isArray(v)) {
      for (const item of v) { const m = buscar(item); if (m) return m; }
      return null;
    }
    if (typeof v === "object") {
      for (const val of Object.values(v)) { const m = buscar(val); if (m) return m; }
    }
    return null;
  };
  return buscar(json);
}

export function usePresupuesto(anioInicial, mesCorteInicial) {
  const [anio, setAnio] = useState(anioInicial);
  const [mesCorte, setMesCorte] = useState(mesCorteInicial);
  const [arbol, setArbol] = useState([]);
  const [totales, setTotales] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const qs = new URLSearchParams({ anio: String(anio), mes_corte: String(mesCorte) });
      const res = await apiFetch(`/api/finance/presupuesto/?${qs}`);
      const json = await res.json();
      setArbol(json.arbol ?? []);
      setTotales(json.totales ?? null);
    } catch {
    } finally {
      setLoading(false);
    }
  }, [anio, mesCorte]);

  useEffect(() => {
    load();
  }, [load]);

  async function guardar(lineas) {
    setSaving(true);
    try {
      const res = await apiFetch("/api/finance/presupuesto/guardar/", {
        method: "POST",
        body: JSON.stringify({ anio, lineas }),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(extraerError(json) || "Error al guardar el presupuesto");
      await load();
      return json;
    } finally {
      setSaving(false);
    }
  }

  return { anio, setAnio, mesCorte, setMesCorte, arbol, totales, loading, saving, guardar };
}
